// extracted by mini-css-extract-plugin
export default {"course-list":"styles_course-list__+ZFEE","course-nav":"styles_course-nav__DUeJT","present-course":"styles_present-course__4gxOu"};